import React from 'react';

export const getRoleSimpleList = () => ['farrier', 'veterinarian', 'staff', 'admin', 'owner'];
export const getRoleList = () => ['farrier', 'veterinarian', 'staff', 'admin', 'owner'];

export const getRoleDescription = (role) => {
  switch (role) {
    case 'farrier':
      return (
        <div>
          Users with this role will have access to horses and their tasks including any farrier tasks.
        </div>
      );
    case 'veterinarian':
      return (
        <div>
          Users with this role will be able to view medical information about the horses in your barn.
        </div>
      );
    case 'staff':
      return (
        <div>
          Users with this role have basic access to the Questri Barn and data in order to perform assigned duties.
          These individuals will have access to the barn board and tasks page where they will be able to provide updates to their assigned work.
          In addition, staff can view data about horses at the barn, and add their own horse notes.
          <div>
            <small>Slightly elevated permissions on top of a general user, more access to horse data/modifications.</small>
          </div>
        </div>
      );
    case 'admin':
      return (
        <div>
          Users with this role can access the settings pages and features including:
          Modifying Users and/or access, modifying Barn Settings (locations, feeds, task, schedules),
          modifying horses and associated data/settings. In addition, admins can override data associated with generated tasks.
          <div>
            <small>Elevated permissions on top of staff role.</small>
          </div>
        </div>
      );
    case 'owner':
      return (
        <div>
          Users with this role can access billing information
          and other sensitive features for the Questri Barn.
          <div>
            <small>There must be at least one owner in the Questri Barn at all times.</small>
          </div>
        </div>
      );
    default:
      return <div>Not a valid role</div>;
  }
};

export const getRoleFeatures = (role) => {
  switch (role) {
    case 'farrier':
      return ['Basic user featues including access to horsee tasks and farrier information'];
    case 'veterinarian':
      return ['Basic user features including access to horse medical information'];
    case 'staff':
      return ['View Barn Board', 'View Tasks', 'Initiate New Tasks', 'Update Tasks', 'View Horses', 'Add Horse Notes', 'Access/Update User Profile & Preferences'];
    case 'admin':
      return ['Same Features as Staff Plus...', 'Add or Remove Users From Questri Barn', 'Create or Update Settings (Locations, Feeds, TaskS', 'Create or Update Horses', 'Override Tasks'];
    case 'owner':
      return ['Same Features as Staff and Admin Plus...', 'Update Questri Barn Settings', 'Update Questri Barn Billing Information'];
    default:
      return ['Not a valid role'];
  }
};

export const formatStringOfRolesIntoArray = (rolesString) => {
  if (rolesString === undefined || rolesString === null || rolesString === '' || rolesString === '[]') {
    return [];
  }
  let parsedRoleString = rolesString.replace('[', '');
  parsedRoleString = parsedRoleString.replace(']', '');
  parsedRoleString = parsedRoleString.replace(/\s/g, '');
  return parsedRoleString.split(',');
};
